import { HttpInterceptorFn } from '@angular/common/http'
import { inject } from '@angular/core'

import { HttpRoutes } from '@enums/http-routes'
import { TicketInfoState } from '@states/ticket-info'

const INCLUDED_PATHS = [
	HttpRoutes.GuestPageConfiguration,
	HttpRoutes.WindcavePayment,
	HttpRoutes.FreedompayInit,
	HttpRoutes.FreedompaySubmit,
]

export const identifiersInterceptor: HttpInterceptorFn = (req, next) => {
	const ticketInfoState = inject(TicketInfoState)
	const operatorCompanyId = ticketInfoState.operatorCompanyId()
	const parkingLocationId = ticketInfoState.parkingLocationId()
	const isIncludedPath = INCLUDED_PATHS.some((path) => req.url.includes(path))

	if (isIncludedPath && operatorCompanyId && parkingLocationId) {
		const headers = req.headers
			.set('Operator-Id', String(operatorCompanyId))
			.set('Location-Id', String(parkingLocationId))

		return next(req.clone({ headers }))
	}

	return next(req)
}
